import { useEffect, useRef } from 'react';

const CanvasDrawer = ({
  width,
  height,
  pointsGroup,
  backgroundImg,
  onlineScale
}) => {
  const canvasTarget = useRef(null);
  useEffect(() => {
    if (!backgroundImg) {
      return;
    }
    const backgroundPic = backgroundImg.cloneNode(false);
    const ctx = canvasTarget.current.getContext('2d');
    ctx.clearRect(0, 0, width, height);
    const scaleX = width / backgroundPic.width;
    const scaleY = height / backgroundPic.height;
    const CommonScale = Math.min(scaleX, scaleY) * onlineScale;
    let moveY = 0;
    let moveX = 0;
    if (scaleX > scaleY) {
      moveX = (width - backgroundImg.width * scaleY) / 2;
      ctx.drawImage(
        backgroundImg,
        moveX,
        0,
        backgroundImg.width * scaleY,
        height
      );
    } else {
      moveY = (height - backgroundImg.height * scaleX) / 2;
      ctx.drawImage(
        backgroundImg,
        0,
        moveY,
        width,
        backgroundImg.height * scaleX
      );
    }
    if (!pointsGroup || !Array.isArray(pointsGroup)) {
      return;
    }
    pointsGroup.forEach((points) => {
      if (points.type && points.type === 'circular') {
        ctx.beginPath();
        ctx.strokeStyle = 'red';
        ctx.arc(
          points.points[0] * CommonScale + moveX,
          points.points[1] * CommonScale + moveY,
          points.radius * CommonScale,
          0,
          Math.PI * 2,
          false
        );
        ctx.closePath();
        ctx.stroke();
      } else if (points.type === 'line') {
        ctx.beginPath();
        points.points.map((point, index) => {
          if (index === 0) {
            ctx.moveTo(
              point[0] * CommonScale + moveX,
              point[1] * CommonScale + moveY
            );
          } else {
            ctx.lineTo(
              point[0] * CommonScale + moveX,
              point[1] * CommonScale + moveY
            );
          }
          return true;
        });
        if (points.result === 1) {
          ctx.strokeStyle = 'green';
        } else {
          ctx.strokeStyle = 'red';
        }
        ctx.stroke();
      } else {
        ctx.beginPath();
        points.points.map((point, index) => {
          if (index === 0) {
            ctx.moveTo(
              point[0] * CommonScale + moveX,
              point[1] * CommonScale + moveY
            );
          } else {
            ctx.lineTo(
              point[0] * CommonScale + moveX,
              point[1] * CommonScale + moveY
            );
          }
          return true;
        });
        if (points.result === 1) {
          ctx.strokeStyle = 'green';
        } else {
          ctx.strokeStyle = 'red';
        }
        ctx.closePath();
        ctx.stroke();
      }
    });
  }, [backgroundImg, height, onlineScale, pointsGroup, width]);
  return <canvas width={width} height={height} ref={canvasTarget} />;
};

export default CanvasDrawer;
